import {Record, List} from 'immutable';
import pluralize from 'pluralize';

export default class CoachingTodo extends Record({
  pickReviewType: undefined, // Boolean
  callsToAdd: undefined, // Number (integer)
  requiredUnansweredQuestions: 0,
  optionalUnansweredQuestions: 0,
  callsToScore: List(),
  callsToComment: List(),
  done: undefined, // Boolean
}) {
  readonly pickReviewType: boolean;
  readonly callsToAdd: number;
  readonly requiredUnansweredQuestions: number;
  readonly optionalUnansweredQuestions: number;
  readonly callsToScore: any;
  readonly callsToComment: any;
  readonly done: boolean;

  constructor(object: Partial<CoachingTodo> = {}) {
    super({
      ...object,
      callsToScore: List(object.callsToScore),
      callsToComment: List(object.callsToComment),
    });
  }

  toPhrase() {
    if (this.pickReviewType) {
      return 'select a meeting type for this review';
    }
    const callPhrase = this.callPhrase();
    const questionPhrase = this.questionPhrase(false);
    if (callPhrase && questionPhrase) {
      return `${callPhrase} and ${questionPhrase}`;
    } else if (callPhrase) {
      return callPhrase;
    } else {
      return questionPhrase;
    }
  }

  callPhrase() {
    const {callsToAdd, callsToScore, callsToComment} = this;
    if (callsToAdd > 0) {
      return `add ${numCalls(callsToAdd)}`;
    }

    if (!callsToScore.isEmpty() && !callsToComment.isEmpty()) {
      return 'score and comment on calls';
    }

    if (!callsToScore.isEmpty()) {
      return `score ${numCalls(callsToScore.size)}`;
    }

    if (!callsToComment.isEmpty()) {
      return `comment on ${numCalls(callsToComment.size)}`;
    }
  }

  questionPhrase(capitalize = false) {
    const {requiredUnansweredQuestions} = this;
    const firstLetter = capitalize ? 'A' : 'a';
    if (requiredUnansweredQuestions > 0) {
      return `${firstLetter}nswer ${numberAndNoun(requiredUnansweredQuestions, 'question')}`;
    }
  }

  callIds() {
    return this.callsToScore.concat(this.callsToComment).toSet();
  }
}

const numberAndNoun = (num, word) => `${num} ${pluralize(word, num)}`;

const numCalls = num => numberAndNoun(num, 'call');
